import { useEffect } from 'react';
import { useDispatch, useSelector } from 'src/redux/store';
import { getPracticeItem } from 'src/redux/slices/practice';

/**
 * Keep `state.practice.practice` (the full practice record with `preferences`)
 * loaded for the ACTIVE practice on every dashboard route.
 *
 * Why: feature gates such as attendance capture (`attendanceUiFlag.js`) and
 * Follow-Up V2 (`useIsFollowUpV2Practice`) read `state.practice.practice
 * .preferences`. Only the dashboard home (GeneralApp), the lead tables and a
 * few popups ever dispatched `getPracticeItem`, so a direct load or browser
 * refresh of e.g. the lead-detail page left the slice empty and every gate
 * read "off" (30 Oct 2026 flag-on smoke: refreshed lead page → legacy
 * attendance path → backend 409). The lead page's own practice fetch goes to
 * the separate `singlePractice` slice, which the gates do not read.
 *
 * Mirrors GeneralApp's loader: fetch when nothing is loaded or when the loaded
 * practice is not the active one (the header resets the slice on a switch).
 * `callApi` dedupes identical in-flight GETs, so this never double-fetches
 * alongside GeneralApp.
 */
export default function useEnsurePracticeDetail(practiceId) {
    const dispatch = useDispatch();
    const loadedPracticeDetailId = useSelector((state) => state.practice?.practice?.id);
    useEffect(() => {
        if (practiceId === null || practiceId === undefined || practiceId === '') return;
        if (String(loadedPracticeDetailId) === String(practiceId)) return;
        dispatch(getPracticeItem(practiceId));
    }, [practiceId, loadedPracticeDetailId, dispatch]);
}
